import { Injectable } from '@angular/core';
import { environment } from "../../environments/environment"
import { HttpClient, HttpHeaders ,HttpParams} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class FlightService {

  constructor(private http:HttpClient) { }

  getFlightList() {
    let header = new HttpHeaders();
    let httpParam : HttpParams=new HttpParams();
      return this.http.post( environment.API_URL+"/api/crm/staticdata/airports" ,{headers : header, observe : "body", params : httpParam,responseType : "json"})  
  }
  getDealCodeList() {
    let httpParam : HttpParams=new HttpParams();
      return this.http.get( environment.API_URL+"/api/crm/allCorporateUsers" ,{ observe : "body", params : httpParam,responseType : "json"})  
  }

  SearchFlight(result:any){
    let headers = new HttpHeaders();
    return this.http.post(environment.API_URL+"/api/product/air/_search/v1",result,{headers : headers,observe:"response"});

  }
   SearchRescheduleFlight(result:any){
    let headers = new HttpHeaders();
    return this.http.post(environment.API_URL+"/api/product/air/reschedule/v1/search",result,{headers : headers,observe:"response"});

  }


  
  getReprice(request:any) {
    let header = new HttpHeaders();
    let httpParam : HttpParams=new HttpParams();
      return this.http.post( environment.API_URL+"/api/product/air/reprice/v1",request ,{headers : header, observe : "body", params : httpParam,responseType : "json"})  
  }

  getbooking(orderId:any) {
    let header = new HttpHeaders();
    let httpParam : HttpParams=new HttpParams();
      return this.http.post( environment.API_URL+"/api/order/book/v1/"+orderId ,{headers : header, observe : "body", params : httpParam,responseType : "json"})  
  }

  getManualbooking(orderId:any) {
    console.log("service")
    let header = new HttpHeaders();
    let httpParam : HttpParams=new HttpParams();
      return this.http.post( environment.API_URL+"/api/order/book/v1/manual/"+orderId ,{headers : header, observe : "body", params : httpParam,responseType : "json"})  
  }
  
  generateOrder(request:any){
    let header = new HttpHeaders();
    let httpParam : HttpParams=new HttpParams();
      return this.http.post( environment.API_URL+"/api/order/v1",request ,{headers : header, observe : "body", params : httpParam,responseType : "json"})  
  }
   generateAutoReschOrder(request:any){
    let header = new HttpHeaders();
    let httpParam : HttpParams=new HttpParams();
      return this.http.post( environment.API_URL+"/api/product/air/reschedule/v1/amendment",request ,{headers : header, observe : "body", params : httpParam,responseType : "json"})  
  }
  getflightDatabyOrderID(OrderID:any){
    let header = new HttpHeaders();
    let httpParam : HttpParams=new HttpParams();
      return this.http.post( environment.API_URL+"/api/order/details/v1/"+OrderID ,{headers : header, observe : "body", params : httpParam,responseType : "json"})  
  }
  getflightDatabyCartID(OrderID:any){
    let header = new HttpHeaders();
    let httpParam : HttpParams=new HttpParams();
      return this.http.post( environment.API_URL+"/api/order/details/v1/manual/"+OrderID ,{headers : header, observe : "body", params : httpParam,responseType : "json"})  
  }
  
  getAllData(OrderID:any){
    let header = new HttpHeaders();
    let httpParam : HttpParams=new HttpParams();
      return this.http.post( environment.API_URL+"/api/order/invoice/v1/"+OrderID ,{headers : header, observe : "body", params : httpParam,responseType : "json"})  
  }

  getAllHotelData(OrderID:any){
    let header = new HttpHeaders();
    let httpParam : HttpParams=new HttpParams();
      return this.http.post( environment.API_URL+"/api/order/hotel/invoice/v1/"+OrderID ,{headers : header, observe : "body", params : httpParam,responseType : "json"})  
  }
  OrderId(orderId:any,request:any){
    let header = new HttpHeaders();
    let httpParam : HttpParams=new HttpParams();
      return this.http.post( environment.API_URL+"/api/order/v1/"+orderId,request ,{headers : header, observe : "body", params : httpParam,responseType : "json"})  
  }
OrderReschId(request:any){
    let header = new HttpHeaders();
    let httpParam : HttpParams=new HttpParams();
      return this.http.post( environment.API_URL+"/api/product/air/reschedule/v1/payment/update",request ,{headers : header, observe : "body", params : httpParam,responseType : "json"})  
  }
  
  OrderIdStatus(orderId:any){
    let header = new HttpHeaders();
    let httpParam : HttpParams=new HttpParams();
      return this.http.post( environment.API_URL+"/api/order/status/v1/"+orderId ,{headers : header, observe : "body", params : httpParam,responseType : "json"})  
  }
  OrderManualId(orderId:any,request:any){
    let header = new HttpHeaders();
    let httpParam : HttpParams=new HttpParams();
      return this.http.post( environment.API_URL+"/api/order/v1/manuals/"+orderId,request ,{headers : header, observe : "body", params : httpParam,responseType : "json"})  
  }
  pnrRetreive(request:any){
    let header = new HttpHeaders();
    let httpParam : HttpParams=new HttpParams();
      return this.http.post( environment.API_URL+"/api/product/air/_search/pnr/v1",request ,{headers : header, observe : "body", params : httpParam,responseType : "json"})  
  }
  

  CommercialBooking(orderId:any){
    let header = new HttpHeaders();
    let httpParam : HttpParams=new HttpParams();
      return this.http.post( environment.API_URL+"/api/commercial/air/COMMISSION/"+orderId ,{headers : header, observe : "body", params : httpParam,responseType : "json"})  
  }
  downloadPdf(orderId:any){
    let header = new HttpHeaders();
    let httpParam : HttpParams=new HttpParams();
    httpParam=httpParam.append("orderId", orderId);
    httpParam=httpParam.append("invoiceLabel", 'C');

      return this.http.get( environment.API_URL+"/api/order/invoice/v1" ,{headers : header, observe : "body", params : httpParam,responseType : "blob"})  
  }
  downloadCartPdf(orderId:any,invoiceLabel:any){
    let header = new HttpHeaders();
    let httpParam : HttpParams=new HttpParams();
    httpParam=httpParam.append("orderId", orderId);
    httpParam=httpParam.append("invoiceLabel", invoiceLabel);

      return this.http.get( environment.API_URL+"/api/order/invoice/v1" ,{headers : header, observe : "body", params : httpParam,responseType : "blob"})  
  }
  downloadAgentPdf(orderId:any,invoiceLabel:any,pricing:any){
    let header = new HttpHeaders();
    let httpParam : HttpParams=new HttpParams();
    httpParam=httpParam.append("orderId", orderId);
    httpParam=httpParam.append("invoiceLabel", invoiceLabel);
    httpParam=httpParam.append("pricingLabel", pricing);

      return this.http.get( environment.API_URL+"/api/order/invoice/v1" ,{headers : header, observe : "body", params : httpParam,responseType : "blob"})  
  }
  
  UpdateAgentmarkup(request:any){
    let header = new HttpHeaders();
    let httpParam : HttpParams=new HttpParams();
      return this.http.post( environment.API_URL+"/api/order/v1/update/agentmarkup" ,request,{headers : header, observe : "body", params : httpParam,responseType : "json"})  
  }
    
  notesSave(request:any){
    let header = new HttpHeaders();
    let httpParam : HttpParams=new HttpParams();
      return this.http.post( environment.API_URL+"/api/order/v1/notes/save" ,request,{headers : header, observe : "body", params : httpParam,responseType : "json"})  
  }
  rules(){
    let header = new HttpHeaders();
    let httpParam : HttpParams=new HttpParams();
      return this.http.get( environment.API_URL+"/api/policy/rules/1234/AIR/ux/BPC" ,{headers : header, observe : "body", params : httpParam,responseType : "json"})  
  }
  getFareRules(request:any){
    let header = new HttpHeaders();
    let httpParam : HttpParams=new HttpParams();
      return this.http.post( environment.API_URL+"/api/product/air/_fare/v1" ,request,{headers : header, observe : "body", params : httpParam,responseType : "json"})  
  }
  SeatMapping(request:any,orderId:any,passenger:any){
 let PassengerData:any=[]
 passenger.forEach((item:any)=>{
  let traveller:any={
    title:item?.passengerTitle,
    firstName:item?.firstName,
    lastName:item?.lastName,
    paxType:item?.passengerType,
    gender:item?.gender
  }
  PassengerData.push(traveller)
 })
   let param:any={
    fromAirport:request.selectedFlight[0].fromAirport,
    toAirport:request.selectedFlight[0].toAirport,
    paxDetails:PassengerData
    }
    let header = new HttpHeaders();
    let httpParam : HttpParams=new HttpParams();
      return this.http.post( environment.API_URL+"/api/product/air/seatMap/v1/"+orderId ,param,{headers : header, observe : "body", params : httpParam,responseType : "json"})  
  }
  mealMapping(request:any,orderId:any,ssrRequestType:any){
    let param:any={
      fromAirport:request.selectedFlight[0]?.fromAirport,
      toAirport:request.selectedFlight[0]?.toAirport,
      ssrRequestType:ssrRequestType,
      paxKey:request?.paxKey
      }
    let header = new HttpHeaders();
    let httpParam : HttpParams=new HttpParams();
      return this.http.post( environment.API_URL+"/api/product/air/ssrMap/v1/"+orderId ,param,{headers : header, observe : "body", params : httpParam,responseType : "json"})  
  }
  getMeal(request:any){
    let headers = new HttpHeaders();
    return this.http.post(environment.API_URL+"/api/product/air/source/carriermeals",request,{headers : headers,observe:"response"});

  }


  getEquipment(code:any) {
    let header = new HttpHeaders();
    let httpParam : HttpParams=new HttpParams();
      return this.http.post( environment.API_URL+"/api/product/air/equipment/"+code ,{headers : header, observe : "body", params : httpParam,responseType : "json"})  
  }

  optionEmailSend(body:any) {
    let header = new HttpHeaders();
    let httpParam : HttpParams=new HttpParams();
      return this.http.post( environment.API_URL+"/api/sanchar/option/email",body ,{observe:"response"})  
  }

  AIR_SHOW_INCENTIVE() {
    let header = new HttpHeaders();
    let httpParam : HttpParams=new HttpParams();
      return this.http.get( environment.API_URL+"/api/policy/rule/AIR/AGENT/AIR_SEARCH_RESULT_UI/AIR_SHOW_INCENTIVE" ,{ observe : "body", params : httpParam,responseType : "json"})  
  }
  
  
  show_Duplicate(request:any){
    let headers = new HttpHeaders();
    return this.http.post(environment.API_URL+"/api/preorder/validate/booking",request,{observe:"response"});

  }
  
  accept_cancelDuplicate(request:any,orderId:any){
    let headers = new HttpHeaders();
    return this.http.post(environment.API_URL+"/api/order/v1/dup/validation/"+orderId,request,{observe:"response"});

  }
}
